<template>
  <div class="approve-field clearfix">
    <p class="filed-title">{{ $locale("schedule.reflectionTime") }}</p>
    <el-row>
      <el-col :span="12">
        <CommDatePicker
          v-bind="$attrs"
          v-on="changeListeners"
          :value="value"
          :disabled="isDisableDate || isDisable"
          :pickerOptions="pickerOptions"
          :showWeekly="true"
          @change="changleHandler"
          width="100%"
       />
      </el-col>
      <el-col v-if="isForScheduleAdd" :span="11" :offset="1" class="picker-radio-group">
        <el-radio-group v-model="isReflect" @change="reflectChangeActionForSchedule" :disabled="isDisable">
          <el-radio :label="true">{{$locale("global.instant")}}</el-radio>
          <el-radio :label="false">{{$locale("global.reflect")}}</el-radio>
        </el-radio-group>
      </el-col>
      <el-col v-else :span="11" :offset="1" class="picker-radio-group" :disabled="isDisable">
        <el-radio-group :value="isInstant" @change="reflectChangeAction">
          <el-radio :label="true">{{$locale("global.instant")}}</el-radio>
          <el-radio :label="false">{{$locale("global.reflect")}}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";

export default {
  name: "approve-field",
  components: {
    CommDatePicker,
  },
  props: {
    value: {
      required: true,
      type: Number,
    },
    formData: {
      required: true,
      type: Object,
    },
    fieldName: {
      required: true,
      type: String,
    },
    isForScheduleAdd: {
      default: () => false
    },
    isDisable: {
      default: () => false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      isReflect: true
    };
  },
  computed: {
    changeListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          change: function(_value) {
            vm.$emit("change", _value);
          }
        }
      );
    },
    isDisableDate() {
      return this.isInstant;
    },
    isInstant() {
      const _today = this.$moment().startOf("day").valueOf();
      const _currentDate = this.$moment(this.value).startOf("day").valueOf();
      return _currentDate <= _today;
    },
  },
  methods: {
    reflectChangeActionForSchedule(_value) {
      const _today = this.$moment().startOf("day").valueOf();
      if (!_value) {
        const _nextDay = this.$moment(_today).add(1, "days").valueOf();
        this.changleHandler(_nextDay);
      } else {
        this.changleHandler(_today);
      }
    },
    reflectChangeAction(_value) {
      const _today = this.$moment().startOf("day").valueOf();
      if (_value) {
        const _nextDay = this.$moment(_today).add(1, "days").valueOf();
        this.changleHandler(_nextDay);
      } else {
        this.changleHandler(_today);
      }
    },
    changleHandler(_value) {
      this.formData[this.fieldName] = _value;
      if (this.isForScheduleAdd) {
        this.formData.reflect = this.isReflect;
      }
      if (this.$listeners.change) {
        this.$emit("change", _value);
      }
    },
    disabledDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _nextDate = this.$moment(_today).add(1, "days").valueOf();

      return time.getTime() < _nextDate;
    }
  },
  watch: {
    formData(val) {
      if (val && this.isForScheduleAdd) {
        this.isReflect = val.reflect
      }
    }
  }
};
</script>

<style scoped lang="less">
.approve-field {
  .filed-title {
    font-size: 1.2rem;
    line-height: 24px;
    color: @primary-dark-grey
  }

  .picker-radio-group {
    line-height: 40px;
  }
}

</style>
